module.exports = __webpack_public_path__ + "static/media/sitio-mantenimiento-sm.8b290be5.png";